(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    // Delegate to native details so re-rendered header blocks need no extra listeners.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.jenna-nav-mobile a');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const menu = link.closest('details');
    menu.open = false;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(destination.hash.slice(1))); } catch { return; }
    if (!target) { menu.querySelector('summary')?.focus({ preventScroll: true }); return; }
    const temporaryTabindex = !target.hasAttribute('tabindex');
    if (temporaryTabindex) {
      target.setAttribute('tabindex', '-1');
      target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
    }
    target.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest?.('.jenna-nav-mobile[open]');
    if (!menu) return;
    event.preventDefault();
    menu.open = false;
    menu.querySelector('summary')?.focus({ preventScroll: true });
  });
  } catch(e) { console.error(e); }
})();

})();
